var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2020-2021 OnFinality Limited authors & contributors
// SPDX-License-Identifier: Apache-2.0
import clsx from 'clsx';
import * as React from 'react';
import { Button, Typography } from '..';
import styles from './Dropdown.module.css';
function getItemsText(item) {
    var _a;
    return (_a = item === null || item === void 0 ? void 0 : item.label) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.key;
}
var DropdownItem = function (_a) {
    var item = _a.item, className = _a.className, onClick = _a.onClick;
    if (!item)
        return null;
    return (_jsx(Typography, __assign({ className: clsx(styles.listItem, className), onClick: onClick }, { children: getItemsText(item) }), item.key));
};
var Dropdown = function (_a) {
    var selected = _a.selected, onSelected = _a.onSelected, className = _a.className, listClassName = _a.listClassName, dropdownClass = _a.dropdownClass, items = _a.items, children = _a.children, rest = __rest(_a, ["selected", "onSelected", "className", "listClassName", "dropdownClass", "items", "children"]);
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var toggleOpen = function () { return setIsOpen(function (open) { return !open; }); };
    var handleSelected = function (key, index) {
        setIsOpen(false);
        onSelected === null || onSelected === void 0 ? void 0 : onSelected(key, index);
    };
    var renderOpen = function () {
        if (!isOpen)
            return null;
        return (_jsx("div", __assign({ className: clsx(styles.list, listClassName) }, { children: items.map(function (item, idx) { return (_jsx(DropdownItem, { item: item, onClick: function () { return handleSelected(item.key, idx); }, className: selected === idx ? styles.selected : undefined }, item.key)); }) }), void 0));
    };
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    return (_jsxs("div", __assign({ className: clsx(styles.container, className) }, { children: [_jsx(Button, __assign({ type: "secondary", size: "medium", colorScheme: "standard" }, rest, { className: dropdownClass, label: !children ? getItemsText(items[selected !== null && selected !== void 0 ? selected : 0]) : undefined, onClick: toggleOpen, leftItem: children && _jsx("div", __assign({ className: styles.children }, { children: children }), void 0), rightItem: _jsx("i", { className: "bi-chevron-".concat(isOpen ? 'up' : 'down'), role: "img", "aria-label": "chevron-".concat(isOpen ? 'up' : 'down') }, void 0) }), void 0), renderOpen()] }), void 0));
};
export default Dropdown;
